/**
 * Created by Ning Jiang on 2021-05-28.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {ElGordosRevenge} from "../../ElGordosRevenge";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TimelineLite} from "gsap";
import {EGRS1Symbol} from "../../symbol/EGRS1Symbol";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ElGordosRevengeBackground} from "../../view/ElGordosRevengeBackground";

export class S1LandingController extends ReelStopPresentationController {

    public scatters:EGRS1Symbol[] = [];
    private _animations:TimelineLite[] = [];

    constructor() {
        super("S1LandingController");

        if(ElGordosRevenge.model.isRestore) {
            const data = ElGordosRevenge.model.parsedInitData;
            if(data.mode === GameMode.NORMAL && data.nextMode.includes(GameMode.FREESPIN)) {
                ElGordosRevenge.model.parsedInitData.S1Positions.forEach((symId, reelId) => {
                    if(symId > -1) {
                        const sym = <EGRS1Symbol>ElGordosRevenge.reels[reelId].getSymbol(symId);
                        this.scatters.push(sym);
                        if(data.nextMode === GameMode.FREESPIN_SUPER) {
                            sym.restoreUpgrade();
                        } else {
                            sym.restoreS1();
                        }
                    }
                });
            }
        }
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        const scatterPosition = ElGordosRevenge.model.parsedGameData.S1Positions![data.reelId];
        if(scatterPosition === -1) {
            if(data.reelId < 3) {
                return Promise.resolve();
            }
            const wasNearWinPlaying = ElGordosRevenge.nearWinView.isScatterNearWinPlaying();
            if(data.reelId === 3) {
                if(this.tryPlayScatterNearWin(4)) {
                    if(wasNearWinPlaying) {
                        ElGordosRevenge.nearWinView.playAnticipationNoScatterLand(3);
                    }
                } else {
                    this.tryPlayBigWinNearWin(4);
                }
                return Promise.resolve();
            }
            if(data.reelId === 4) {
                if(this.tryPlayScatterNearWin(5)) {
                    if(wasNearWinPlaying) {
                        ElGordosRevenge.nearWinView.playAnticipationNoScatterLand(4);
                    }
                } else {
                    ElGordosRevenge.nearWinView.stopScatterNearWin(4);
                    this.tryPlayBigWinNearWin(5);
                }
                return Promise.resolve();
            }
            if(data.reelId === 5) {
                ElGordosRevenge.nearWinView.stopScatterNearWin(5);
                ElGordosRevenge.nearWinView.stopBigWinNearWin(5);
                return Promise.resolve();
            }
        }

        const symbol = <EGRS1Symbol>ElGordosRevenge.reels[data.reelId].getSymbol(scatterPosition);
        this.scatters.push(<any>symbol);

        if(this.scatters.length === 1) {
            if(data.reelId < 4) {
                return Promise.resolve(this.playAttentionAnimation(symbol, 1, true));
            } else {
                return Promise.resolve();
            }
        }
        if(this.scatters.length === 2) {
            if(!this.tryPlayScatterNearWin(data.reelId + 1)) {
                this.tryPlayBigWinNearWin(data.reelId + 1);
            }
            const promises:Promise<any>[] = [];
            this.scatters.forEach((s, i) => {
                promises.push(this.playAttentionAnimation(s, 2, i === 1));
            });
            return Promise.all(promises);
        }
        if(this.scatters.length === 3) {
            this.tryPlayScatterNearWin(data.reelId + 1);
            const promises:Promise<any>[] = [];
            this.scatters.forEach((s, i) => {
                promises.push(this.playAttentionAnimation(s, 3, i === 2, i === 2));
            });
            return Promise.all(promises);
        }

        // if(this._scatters.length === 4), maybe 4th BN like animation if we have later.
        this.tryPlayScatterNearWin(5);
        return Promise.resolve(this.playAttentionAnimation(symbol, 4, true, true));
    }

    private playAttentionAnimation(symbol:EGRS1Symbol, amount:number, playSound:boolean, playEffect?:boolean):Promise<any> {
        Logger.logDev(`playing S1 attention on reel ${symbol.reelId}, amount=${amount}`)
        if(amount > 1) {
            ElGordosRevenge.reels[symbol.reelId].reelView.addWinSymbol(symbol);
        }
        let tl = symbol.playAmountLanding(amount, playSound);
        tl.add(() => {
            if(amount >= 2) {
                symbol.playAmountLandingLoop(amount);
            }
        });
        if(playEffect) {
            tl.add(() => {
                ElGordosRevengeBackground.shakeStageOnce(this.scatters.length > 3 ? 0.5 : 0.3);
            }, 0);
        }
        this._animations.push(tl);
        return Promise.resolve(tl).then(res => {
            ArrayHelper.removeFirstMatchElement(this._animations, tl);
        });
    }

    private tryPlayScatterNearWin(reelId:number):boolean {
        if(ElGordosRevenge.reels[reelId].isQuickStop) {
            return false;
        }
        if(this.scatters.length < 2) {
            return false;
        }
        if(reelId === 5 && this.scatters.length < 3) {
            return false;
        }
        if(ElGordosRevenge.model.parsedGameData.nearWinReels[reelId]) {
            ElGordosRevenge.nearWinView.playScatterNearWin(reelId, reelId === 5 ? 4 : this.scatters.length);
            return true
        }
        return false;
    }

    private tryPlayBigWinNearWin(reelId:number):void {
        // if(ElGordosRevenge.reels[reelId].isQuickStop) {
        //     return false;
        // }
        if(reelId < 4) {
            return;
        }
        if(ElGordosRevenge.model.parsedGameData.nearWinBigWinReels[reelId]) {
            ElGordosRevenge.nearWinView.playBigWinNearWin(reelId);
            return;
        }

        if(reelId === 5 && ElGordosRevenge.nearWinView.isBigWinNearWinPlaying()) {
            ElGordosRevenge.nearWinView.stopBigWinNearWin();
        }
    }

    // public onSpinStart():void {
    //     if(this._scatters?.length > 1) {
    //         this._scatters.forEach(s => {
    //             ElGordosRevenge.reels[s.reelId].reelView.addWinSymbol(s);
    //         });
    //     }
    // }

    protected reset() {
        super.reset();
        this.scatters = [];
    }
}